import "./styles/Footer.css";

import { FaInstagram, FaWhatsapp } from "react-icons/fa";

import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="iconsArena">
        <a
          href="https://instagram.com/arenacentralsj"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className="iconeFooter" />
        </a>
        <a
          href="https://wa.me/5532999649956"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="iconeFooter" />
        </a>
      </div>
      <div className="textsFooter">
        <h5>
          <Link to="/politica-cancelamento" style={{color: "white", textDecoration: "underline"}}>
            Política de cancelamento
          </Link>
        </h5>
        <h5>
          Desenvolvido e criado por{" "}
          <a
            href="http://instagram.com/e.cipriani"
            target="_blank"
            rel="noreferrer"
          >
            Enzo Cipriani
          </a>
          .
        </h5>
      </div>
    </footer>
  );
}
